/**
 * CommentImageViewer
 */

class CommentImageViewer {

  private commentImageSelector = `comment-image`;

  private mobileImageViewer: any;

  constructor() {
    this.addEvent();
  }

  private popView( src: string ) {
    const win = window as any;
    if ( win.nc && win.nc.ui && win.nc.ui.ImageViewer ) {
      this.mobileImageViewer = new win.nc.ui.ImageViewer( jQuery( 'body' ), [ src ], {commentUrl: ''} );
      this.mobileImageViewer.show();
    }
  }

  private addEvent() {
    jQuery( 'body' ).on( 'click', `.${this.commentImageSelector}`, ( evt ) => {
      const src = jQuery( evt.currentTarget ).attr( 'src' );
      evt.preventDefault();
      this.popView( src );
    });
  }
}

export default CommentImageViewer;
